export var ENTITY_TYPE = {
  LEAD: 'LEAD'
};
export var ON_THEME_CHANGE = 'ON_THEME_CHANGE';
export var ON_LANGUAGE_CHANGE = 'ON_LANGUAGE_CHANGE';
export var SHOW_TOUR = 'SHOW_TOUR';
export var UPDATE_URL = 'UPDATE_URL';
export var ON_SIGN_OUT = 'ON_SIGN_OUT';
export var OPEN_FORM = 'OPEN_FORM';
export var SHOW_ALERT = 'SHOW_ALERT';
export var OPEN_ENTITY_DETAILS = 'OPEN_ENTITY_DETAILS';
export var GET_CONTEXT = 'GET_CONTEXT';
export var GET_PROCESS_FORMS = 'GET_PROCESS_FORMS';
export var RELOAD = 'RELOAD';
export var SIGN_OUT = 'SIGN_OUT';
export var ON_CLICK_2_CALL = 'ON_CLICK_2_CALL';
export var RE_ISSUE_TOKENS = 'RE_ISSUE_TOKENS';
export var ON_BROADCAST_MESSAGE_RECEIVED = 'ON_BROADCAST_MESSAGE_RECEIVED';
export var BROADCAST_MESSAGE = 'BROADCAST_MESSAGE';
export var CLOSE_ENTITY_DETAILS = 'CLOSE_ENTITY_DETAILS';